import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-evaluate_btn_close",
  "use": "icon-evaluate_btn_close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-evaluate_btn_close\"><path d=\"m12 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z\" fill=\"#f2f2f2\" /><g fill=\"#666\"><path d=\"m9 16c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l6-6c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-6 6c-.195.195-.451.293-.707.293z\" /><path d=\"m15 16c-.256 0-.512-.098-.707-.293l-6-6c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l6 6c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/evaluate_btn_close.svg
// module id = QbSk
// module chunks = 87